import { render, staticRenderFns } from "./StartComp.vue?vue&type=template&id=9fac4462"
import script from "./StartComp.vue?vue&type=script&lang=js"
export * from "./StartComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports